module.exports = __webpack_public_path__ + "static/media/video.a34fb402.mp4";